module.exports = __webpack_public_path__ + "static/media/paper-plane.f5f4a640.svg";